

































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import Barrage from '@/components/Barrage.vue';
import data from './data';
import Camera from '@paddlejs-mediapipe/camera';
import * as humanseg from '@paddlejs-models/humanseg/lib/index_gpu';
import { sendShowLog, sendClickLog } from '@/common/js/log';

@Component({
    components: {
        Barrage
    },
})
export default class Home extends Vue {
    private bannerList = data.banner;
    private infoList = data.contain;
    private gitHubUrl = 'https://github.com/PaddlePaddle/Paddle.js';
    private showLive = false;
    private showLoading = true;
    private liveText = '开始体验';
    private camera = null;
    private switchValue = false;
    private backgroundUrl = 'https://paddlejs.cdn.bcebos.com/website/bg.jpg';

    private jumpUrl(act = '', url = this.gitHubUrl) {
        if (act) {
            sendClickLog('pdjs_index', act);
        }
        window.open(url);
    }

    private clickDemoBtn(item, index) {
        sendClickLog('pdjs_index', `demo_${index + 1}`);
        if (item.url) {
            this.jumpUrl('', item.url);
            return;
        }
        item.showCode = !item.showCode;
    }

    private closeMask(e, item) {
        e.stopPropagation();
        item.showCode = !item.showCode;
        sendClickLog('pdjs_index', 'demo_mask');
    }

    private clickShowLive() {
        sendClickLog('pdjs_index', !this.showLive ? 'live_start' : 'live_close');
        if (!this.showLive) {
            this.showLoading = true;
            this.showLive = true;
            this.liveText = '关闭摄像头';
            this.humanSegInit();
            return;
        }
        if (this.camera) {
            this.camera.pause();
            this.camera.stream.getTracks()[0].stop();
        }
        this.resetLiveStatus();
    }

    private resetLiveStatus() {
        this.showLoading = false;
        this.showLive = false;
        this.liveText = '开始体验';
        this.camera = null;
    }

    private async humanSegInit() {
        // 模型预热
        await humanseg.load();
        const videoDom = this.$refs.video[0] as HTMLVideoElement;
        // webrtc
        const canvas = this.$refs.canvas[0] as HTMLCanvasElement;
        const canvas_ctx = canvas.getContext('2d');
        // 页面展示
        const show_canvas = this.$refs.canvasResult[0] as HTMLCanvasElement;

        this.camera = new Camera(videoDom, {
            mirror: true,
            enableOnInactiveState: true,
            videoLoaded: () => {
                this.showLoading = false;
                canvas.width = videoDom.width;
                canvas.height = videoDom.height;
                this.camera.start();
            },
            onFrame: async () => {
                // canvas绘制视频流
                canvas_ctx.drawImage(videoDom, 0, 0, videoDom.width, videoDom.height);
                await humanseg.drawHumanSeg(canvas, show_canvas);
            },
            onError: () => {
                this.resetLiveStatus();
                alert('请开启浏览器摄像头权限~');
            },
            onNotSupported: () => {
                this.resetLiveStatus();
                alert('浏览器不支持获取摄像头权限~');
            },
        });
    }

    private changeSwitch() {
        sendClickLog('pdjs_index', this.switchValue ? 'barrage_open' : 'barrage_close');
    }

    created() {
        sendShowLog('pdjs_index');
    }
}
